/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDesk = createReactComponent("desk", "IconDesk", [
  ["path", { d: "M3 6h18", key: "svg-0" }],
  ["path", { d: "M4 6v13", key: "svg-1" }],
  ["path", { d: "M20 19v-13", key: "svg-2" }],
  ["path", { d: "M4 10h16", key: "svg-3" }],
  ["path", { d: "M15 6v8a2 2 0 0 0 2 2h3", key: "svg-4" }]
]);

export { IconDesk as default };
//# sourceMappingURL=IconDesk.js.map
